/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

class LoginSignup extends HTMLElement {
    constructor () {
      super()
  
      this.triggerEls = this.querySelectorAll('[data-el="login-signup.trigger"]')
      this.formEl = this.querySelector('[data-el="login-signup.form"]')
      this.recoverFormEl = this.querySelector(
        '[data-el="login-signup.recoverForm"]',
      )
  
      this.setupListeners()
      this.checkUrlHash()
    }
  
    setupListeners () {
      this.triggerEls.forEach(button => {
        button.addEventListener('click', () => {
          this.buttonClick()
        })
      })
    }
  
    checkUrlHash () {
      this.hash = window.location.hash
  
      if (this.hash === '#recover') {
        this.buttonClick()
      }
    }
  
    buttonClick () {
      this.formEl.setAttribute(
        'aria-hidden',
        this.formEl.getAttribute('aria-hidden') === 'true' ? 'false' : 'true',
      )
  
      this.recoverFormEl.setAttribute(
        'aria-hidden',
        this.recoverFormEl.getAttribute('aria-hidden') === 'true'
          ? 'false'
          : 'true',
      )
    }
  }
  customElements.define('login-signup', LoginSignup)